var _style, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emj0idelhay1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes emj0idelhay2_ts__ts{0%,25%,75%,to{transform:translate(10px,10px) scale(.01,.01)}50%{transform:translate(10px,10px) scale(1,1)}}@keyframes emj0idelhay3_ts__ts{0%,50%,to{transform:translate(3px,10px) scale(.01,.01)}25%{transform:translate(3px,10px) scale(1,1)}}@keyframes emj0idelhay4_ts__ts{0%,50%,to{transform:translate(17px,10px) scale(.01,.01)}75%{transform:translate(17px,10px) scale(1,1)}}")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.01 0 0 .01 10 10)",
    style: {
      animation: "emj0idelhay2_ts__ts 1200ms linear infinite normal forwards"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "emj0idelhay2",
    r: 2,
    fill: "#0173C6",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.01 0 0 .01 3 10)",
    style: {
      animation: "emj0idelhay3_ts__ts 1200ms linear infinite normal forwards"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "emj0idelhay3",
    r: 2,
    fill: "#0173C6",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.01 0 0 .01 17 10)",
    style: {
      animation: "emj0idelhay4_ts__ts 1200ms linear infinite normal forwards"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "emj0idelhay4",
    r: 2,
    fill: "#0173C6",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.e5db598a.svg";
export { ForwardRef as ReactComponent };